// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"b2eb9a9d","400":"410aac30"}[chunkId] + ".chunk.js";
};